import { purchaseOrderIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const deletePurchaseOrder = {
  name: "deletePurchaseOrder" as const,
  input: z.object({ purchaseOrderId: purchaseOrderIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
